export default {
  title: 'Diätetische Eigenschaften',
};
